// apps/client/src/lib/utils.ts
//
// Utility functions shared across the app
//

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names with Tailwind conflict resolution
 * Usage: cn('bg-red-500', isActive && 'bg-blue-500', className)
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
